import React from "react";
import { Space, TextField } from "@pankod/refine-antd";

import { getActorInitials, getSafeText } from "../utils/audit-log.helpers";

type AuditActorCellProps = {
  actorId?: string | null;
  actorName?: string | null;
};

export const AuditActorCell: React.FC<AuditActorCellProps> = ({
  actorId,
  actorName,
}) => (
  <Space size={10} className="audit-log-actor-cell">
    <span className="audit-log-actor-avatar">
      {getActorInitials(actorName, actorId)}
    </span>
    <span className="audit-log-cell-stack">
      <TextField strong value={getSafeText(actorName || actorId)} />
      {actorName && (
        <span className="audit-log-secondary-text">{getSafeText(actorId)}</span>
      )}
    </span>
  </Space>
);